import { getHeadersWithToken } from '@/utils/http'

export const useHttpRequest = ({ endpoint, filters }) => {
  const fetchData = async (params, successFn, failFn) => {
    const payload = JSON.stringify({ ...params.request, salvePreFilter: { ...filters } })

    try {
      const response = await fetch(endpoint, {
        headers: getHeadersWithToken(),
        method: 'post',
        body: payload
      })

      if (!response.ok) {
        throw new Error('Bad Response')
      }

      let data = await response.json()

      if (typeof successFn === 'function') {
        const result = successFn(data)

        if (result && result.rows) {
          data = result
        }
      }

      params.success({ rowData: data.rows, rowCount: data?.lastRow })
    } catch (error) {
      console.error(error)
      if (typeof failFn === 'function') {
        failFn(error)
      }
      params.fail()
    }
  }

  return {
    httpRequest: {
      fetchData
    }
  }
}
